import type { LockBadge } from '@/components/features/gamification/model/types/gamificationBadges';
import { useTranslations } from 'next-intl';
import { Icon } from '../../Sprite';
import { GmBadge } from '../GmBadge';

interface Props {
  badge: Exclude<LockBadge, null>;
  className?: string;
}

export const GmLockedBadge = ({ badge, className }: Props) => {
  const t = useTranslations('gamification');

  return (
    <GmBadge variant="glass" className={className}>
      <Icon name="block" className="size-2.5" />
      {badge.kind === 'needs-status'
        ? t('need-status', { status: badge.statusName.toUpperCase() })
        : t('coming-soon')}
    </GmBadge>
  );
};
